import { SALARY_BONUSES_LOADER, SET_SALARY_BONUSES } from "./actionType";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  isError: false,
  loading: false,
  error: null,
};

const SalaryBonuses = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_SALARY_BONUSES:
      return {
        ...state,
        data: action.payload,
      };
    case SALARY_BONUSES_LOADER:
      return {
        ...state,
        loading: !state.loading,
      };
    default:
      return state;
  }
};

export default SalaryBonuses;
